// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__14lSA","description":"PatientConsentPreview_description__ExQql"};